import { ErrorMessage } from "@hookform/error-message";
import { useFormContext } from "react-hook-form";

type Radio = {
	id: string;
	label: string;
	value: string;
};

const RadioGroupField = ({
	registeredName,
	label,
	isRequired,
	requiredText,
	radios,
	isClustered = false,
	defaultValue = null,
}: {
	registeredName: string;
	label: string;
	isRequired: boolean;
	requiredText?: string;
	radios: Array<Radio>;
	isClustered?: boolean;
	defaultValue?: string | null;
}) => {
	const {
		register,
		formState: { errors },
	} = useFormContext();

	const clusteredClassName = isClustered ? "justify-start" : "justify-between";

	return (
		<div className="my-5">
			<label className="mb-1.5 ml-2 block text-sm uppercase">
				{label}
				{isRequired && "*"}
			</label>
			{errors && (
				<p className="ml-2 text-xs text-red-500">
					<ErrorMessage errors={errors} name={registeredName} />
				</p>
			)}
			<fieldset className={`${clusteredClassName} flex gap-2 border-none px-2`}>
				{radios &&
					radios.map((radio: Radio, index) => (
						<div key={radio.id}>
							<label className="mr-2 flex cursor-pointer items-center gap-1.5">
								<input
									type="radio"
									id={radio.id}
									value={radio.value}
									defaultChecked={defaultValue === radio.value}
									{...register(registeredName, {
										validate: (value) =>
											(isRequired && value !== "") || requiredText,
									})}
									className="cursor-pointer accent-black"
									{...(0 === index ? { required: true } : {})}
								/>
								{radio.label}
							</label>
						</div>
					))}
			</fieldset>
		</div>
	);
};
export default RadioGroupField;
